export default "__VITE_ASSET__N9rXuFaw__"